// FETCH ALL PROPERTIES FROM COMPACTING_DC DETAILS
export const FETCH_COMPACTING_DC_DETAILS_REQUEST_DK = 'FETCH_COMPACTING_DC_DETAILS_REQUEST_DK';
export const FETCH_COMPACTING_DC_DETAILS_SUCCESS_DK = 'FETCH_COMPACTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_COMPACTING_DC_DETAILS_FAILURE_DK = 'FETCH_COMPACTING_DC_DETAILS_FAILURE_DK';

export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK';
export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK';
export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK';

// FETCH ALL PROPERTIES FROM COMPACTING_DC DETAILS BY ID
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST_DK = 'FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST_DK';
export const FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS_DK = 'FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE_DK = 'FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE_DK';

export const FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST_DK = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST_DK';
export const FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS_DK = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS_DK';
export const FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE_DK = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE_DK';

// CREATE PROPERTIES FOR COMPACTING_DC DETAILS
export const CREATE_COMPACTING_DC_DETAILS_REQUEST_DK = 'CREATE_COMPACTING_DC_DETAILS_REQUEST_DK';
export const CREATE_COMPACTING_DC_DETAILS_SUCCESS_DK = 'CREATE_COMPACTING_DC_DETAILS_SUCCESS_DK';
export const CREATE_COMPACTING_DC_DETAILS_FAILURE_DK = 'CREATE_COMPACTING_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_DC_DETAILS_DK = 'CREATE_USER_FORM_COMPACTING_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR COMPACTING_DC DETAILS
export const UPDATE_COMPACTING_DC_DETAILS_REQUEST_DK = 'UPDATE_COMPACTING_DC_DETAILS_REQUEST_DK';
export const UPDATE_COMPACTING_DC_DETAILS_SUCCESS_DK = 'UPDATE_COMPACTING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_COMPACTING_DC_DETAILS_FAILURE_DK = 'UPDATE_COMPACTING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE COMPACTING_DC_DETAILS
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR COMPACTING_DC DETAILS
export const DELETE_COMPACTING_DC_DETAILS_REQUEST_DK = 'DELETE_COMPACTING_DC_DETAILS_REQUEST_DK';
export const DELETE_COMPACTING_DC_DETAILS_SUCCESS_DK = 'DELETE_COMPACTING_DC_DETAILS_SUCCESS_DK';
export const DELETE_COMPACTING_DC_DETAILS_FAILURE_DK = 'DELETE_COMPACTING_DC_DETAILS_FAILURE_DK';

export const FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const COMPACTING_DC_DETAILS_USERFORM_RESET_DK = 'COMPACTING_DC_DETAILS_USERFORM_RESET_DK';

export const COMPACTING_CLOSE_BTN_POST_REQUEST = 'COMPACTING_CLOSE_BTN_POST_REQUEST'
export const COMPACTING_CLOSE_BTN_POST_SUCCESS = 'COMPACTING_CLOSE_BTN_POST_SUCCESS'
export const COMPACTING_CLOSE_BTN_POST_FALIURE = 'COMPACTING_CLOSE_BTN_POST_FALIURE'



export const COMPACTING_CHECK_ALL_UPDATE_REQUEST = 'COMPACTING_CHECK_ALL_UPDATE_REQUEST'
export const COMPACTING_CHECK_ALL_UPDATE_SUCCESS = 'COMPACTING_CHECK_ALL_UPDATE_SUCCESS'
export const COMPACTING_CHECK_ALL_UPDATE_FALIURE = 'COMPACTING_CHECK_ALL_UPDATE_FALIURE'